export enum Roles {
  "ITD_STAFF" = "itd-staff",
  "ITD_CUSTOMER" = "itd-customer",
  "ITD_ADMIN_FOR_SALES_ACCOUNTS" = "itd-admin-for-sales-accounts",
  "ITD_SALES_PEOPLE_FOR_SALES_ACCOUNTS" = "itd-sales-people-for-sales-accounts",
}
